// IP geo/org lookup — POST /v1/api/ip_info {ips:[...]} → {ok, info:{ip:{org,country,countryCode}}}.
// Go side: internal/ipinfo/ipinfo.go (ip-api.com batch behind a 24h Redis
// cache). The `info` map only contains IPs that resolved — private /
// reserved ones are absent (treat as "no data").

import type { ApiClient } from "./client.js";

export interface IpGeo {
  org: string;
  country: string;
  countryCode: string;
}
export interface IpInfoResult {
  ok: boolean;
  info?: Record<string, IpGeo>;
  error?: string;
}

export function makeIpInfoApi(client: ApiClient) {
  return {
    /** Look up org/country for up to ~100 IPs at once. */
    lookup(ips: string[]): Promise<IpInfoResult> {
      return client.post<IpInfoResult>("/v1/api/ip_info", { ips });
    },
  };
}

export type IpInfoApi = ReturnType<typeof makeIpInfoApi>;
